import { formatARS, BACKEND_URL } from "@/lib/format";
import { useNavigate } from "react-router-dom";
import { Zap } from "lucide-react";
import { withParams } from "@/lib/attribution";

const DIAS = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];
const resolveImg = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);
const slugify = (s) =>
  (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

function diasLabel(d) {
  if (!d || d.length === 7) return "Todos los días";
  if (d.length === 4 && d[0] === 0 && d[3] === 3) return "Lun a Jue";
  if (d.length === 1 && d[0] === 6) return "Domingos";
  return d.map((x) => DIAS[x]).join(" · ");
}

export default function PromoStrip({ rules = [] }) {
  const navigate = useNavigate();
  // Portada: hasta 3 promos. Destacadas primero; si no hay, las de mayor prioridad.
  const destacadas = rules.filter((r) => r.destacada);
  const visibles = (destacadas.length ? destacadas : [...rules].sort((a, b) => (b.prioridad || 0) - (a.prioridad || 0))).slice(0, 3);
  if (!visibles.length) return null;

  return (
    <section className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-xs uppercase tracking-[0.25em] text-gold font-bold mb-1">Se aplican solas en tu carrito</div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl uppercase text-white">
            Promos <span className="text-brand">activas hoy</span>
          </h2>
        </div>
      </div>

      <div className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory thin-scroll -mx-4 px-4">
        {visibles.map((r) => (
          <div
            key={r.id}
            data-testid={`promo-card-${r.id}`}
            className="snap-start shrink-0 w-[280px] sm:w-[340px] bg-panel border border-line hover:border-brand transition-colors duration-300 rounded-xl overflow-hidden flex flex-col"
          >
            {r.imagen && (
              <div className="relative aspect-[4/3] bg-black">
                <img src={resolveImg(r.imagen)} alt={r.nombre} loading="lazy" className="w-full h-full object-cover" />
              </div>
            )}
            <div className="p-4 flex flex-col flex-1">
              <div className="flex gap-2 mb-2 flex-wrap">
                <span className="bg-brand text-black text-[10px] font-black uppercase tracking-widest px-2 py-1 rounded flex items-center gap-1">
                  <Zap className="w-3 h-3" strokeWidth={3} /> Promo
                </span>
                <span className="bg-white/10 border border-white/20 text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded">
                  {diasLabel(r.diasSemana)}
                </span>
              </div>
              <h3 className="font-heading text-xl uppercase text-white leading-tight">{r.nombre}</h3>
              <p className="text-sm text-zinc-400 mt-1 line-clamp-2 flex-1">{r.descripcion}</p>
              <div className="mt-4 flex items-center justify-between">
                <div className="font-heading text-2xl text-gold">{r.descuentoPorcentaje ? `-${r.descuentoPorcentaje}%` : formatARS(r.precioCombo)}</div>
                <button
                  data-testid={`armar-combo-${r.id}`}
                  onClick={() => navigate(withParams(`/promo/${slugify(r.nombre)}`))}
                  className="bg-brand hover:bg-brand-strong text-black font-black uppercase text-xs px-4 py-2 rounded transition-colors duration-200"
                >
                  Armar combo
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
